import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TenantService } from 'src/app/_service/tenant.service';
import { getTenantData } from 'src/app/_model/tenant';

@Component({
  selector: 'app-tenant-selection',
  templateUrl: './tenant-selection.component.html',
  styleUrl: './tenant-selection.component.css'
})
export class TenantSelectionComponent {
  currTenant: any;
  currTenantID = "";
  company = "";
  tenantList: getTenantData[] = [];
  constructor(
    public router: Router,
    public dialogRef: MatDialogRef<TenantSelectionComponent>,
    private tenantService: TenantService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }
  ngOnInit(): void {
    this.currTenantID = this.data.currTenant;
    this.company = this.data.company;
    this.tenantService.getTenantByCompanyID(this.company)
      .subscribe({
        next: async(value: any) => {
          this.tenantList = value;
          this.currTenant = this.tenantList.find(t => t.id === this.currTenantID);
        },
      });
  }

  ngOnDestroy(): void {
    
  }

  onSave() {
    this.dialogRef.close({currTenant: this.currTenant.id, company: this.company});
  }
}
